export default {
    props: {
        monthContent: {
            type: String,
            default: undefined,
            kComposite: 'month.content'
        }, 
        monthWeekNumber: {
            type: String,
            default: undefined,
            kComposite: 'month.weekNumber'
        }, 
        monthEmpty: {
            type: String,
            default: undefined,
            kComposite: 'month.empty'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/Common/Month.js